import { VehicleRepository } from '@/core/vehicle/domain/VehicleRepository.ts'
import { Vehicle } from '@/core/vehicle/domain/Vehicle.ts'

type GetVehicleByPlateUseCaseDependencies = { vehicleRepository: VehicleRepository }

export class GetVehicleByPlateUseCase {
  private readonly vehicleRepository: VehicleRepository
  constructor({ vehicleRepository }: GetVehicleByPlateUseCaseDependencies) {
    this.vehicleRepository = vehicleRepository
  }

  execute = (plate: string): Promise<Vehicle | null> => {
    return this.vehicleRepository.getVehicleByPlate(plate)
  }
}
